
import { useEffect, useState } from "react";
import { getArgumentChanges } from "../../../api";
import { ArgumentHistory } from "../../TrainingArgumentHistory";
import { Button, Tooltip } from "antd";
import { FileAddOutlined } from "@ant-design/icons";
import { fireEvent } from "../../../util";


export const RuntimeChanges = (props) => {
    const { modelArgs } = props;

    const [history, setHistory] = useState([]);

    useEffect(() => {
        getArgumentChanges(modelArgs.run_id).then(setHistory);
    }, [modelArgs]);

    const createTraining = (args) => {
        fireEvent('deriveTraining', args);
    }

    const renderExtra = (k, oldArgs, newArgs) => <span>
        <Tooltip title="Create new training up to (and including) this param change">
            <Button size="small" color="red" type="primary" icon={<FileAddOutlined />} onClick={() => createTraining(newArgs)} />
        </Tooltip>
    </span>


    return (<>
        <ArgumentHistory changes={history} renderExtra={renderExtra} runId={modelArgs.run_id} />
    </>);
};
